import "./App.css";
import React, { useState, useEffect } from "react";
import { Route, BrowserRouter, Routes, Navigate, useOutletContext } from "react-router-dom";
import axios from "axios";
import { apiKey } from "./config/config";
import { hasModuleAccess, rolesConfig } from "./config/rolesConfig";
import "@emran-alhaddad/saudi-riyal-font/index.css";

import LoginPage from "./pages/LoginPage";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import PublicContract from "./pages/PublicContract";

import PrivateRoute from "./components/PrivateRoute";
import RoleRoute from "./components/RoleRoute";
import DashboardLayout from "./layouts/DashboardLayout";

import CustomerPrivateRoute from "./components/CustomerPrivateRoute";
import InvestorPrivateRoute from "./components/InvestorPrivateRoute";

import CustomerLayout from "./layouts/CustomerLayout";
import InvestorLayout from "./layouts/InvestorLayout";

import PortalLoginPage from "./pages/portal/PortalLoginPage";

import CustomerDashboard from "./pages/customer/CustomerDashboard";
import CustomerContractsHistory from "./pages/customer/CustomerContracts";
import ApplyContractForm from "./pages/customer/ApplyContract";
import CustomerApplicationsList from "./pages/customer/CustomerApplications";
import CustomerReportsPage from "./pages/customer/CustomerReports";
import CustomerProfilePage from "./pages/customer/CustomerProfile";

import InvestorDashboardPage from "./pages/investor/InvestorDashboard";
import InvestorTransactionsPage from "./pages/investor/InvestorTransactions";
import InvestorStatementPage from "./pages/investor/InvestorStatement";
import InvestorPoolsPage from "./pages/investor/InvestorPools";
import InvestorProfilePage from "./pages/investor/InvestorProfile";

import BranchContractApplications from "./pages/BranchContractApplications";
import ActivityLogReport from "./pages/ActivityLogReport";

import AddCusgarantor from "./pages/AddCusgarantor";
import AddCustomer from "./pages/AddCustomer";
import AddLightCustomer from "./pages/AddLightCustomer";
import AddLightGuarantor from "./pages/AddLightGuarantor";
import AddLoanList from "./pages/AddLoanList";
import AddNewCommision from "./pages/AddNewCommision";
import AddNewDealer from "./pages/AddNewDealer";
import AddNewDel from "./pages/AddNewDel";
import AddNewInstall from "./pages/AddNewInstall";
import AddNewPool from "./pages/AddNewPool";
import AddNewProfit from "./pages/AddNewProfit";
import AddNewValid from "./pages/AddNewValid";
import Addinvestor from "./pages/Addinvestor";
import AddLightInvestor from "./pages/AddLightInvestor";
import BasicInfo from "./pages/BasicInfo";
import CollectionAndPayment from "./pages/Collection&Payment";
import ContractInfo from "./pages/ContractInfo";
import Contracts from "./pages/Contracts";
import CusManGuarantor from "./pages/CusManGuarantor";
import Customer from "./pages/Customer";
import Dashboard from "./pages/Dashboard";
import DealerList from "./pages/DealerList";
import DealerReport from "./pages/DealerReport";
import Identification from "./pages/Identification";
import InstallmentAndPayment from "./pages/InstallmentAndPayment";
import InstallmentPayment from "./pages/InstallmentPayment";
import InventoryLoanList from "./pages/InventoryLoanList";
import InvesDeposit from "./pages/InvesDeposit";
import InvesTransfer from "./pages/InvesTransfer";
import InvestReport from "./pages/InvestReport";
import InvestmentPool from "./pages/InvestmentPool";
import InvestorRep from "./pages/InvestorRep";
import InvestorReport from "./pages/InvestorReport";
import Item from "./pages/Item";
import ItemReport from "./pages/ItemReport";
import ListOfContract from "./pages/ListOfContract";
import ListOfContractComision from "./pages/ListOfContractComision";
import ListOfDel from "./pages/ListOfDel";
import Loan from "./pages/Loan";
import LoanAvailList from "./pages/LoanAvailList";
import AddLoanRequest from "./pages/AddLoanRequest";
import LoanReport from "./pages/LoanReport";
import InvestorContractReport from "./pages/InvestorContractReport";
import Profie from "./pages/Profie";
import PurchaseInventory from "./pages/PurchaseInventory";
import Report from "./pages/Report";
import Returns from "./pages/Returns";
import TypeOfLoans from "./pages/TypeOfLoan";
import UserProfile from "./pages/UserProfile";
import UserReport from "./pages/UserReports";
import ValidCon from "./pages/ValidCon";
import WithDraw from "./pages/WithDraw";
import Zakat from "./pages/Zakat";
import Accounts from "./pages/Accounts";
import Expenses from "./pages/Expenses";
import AdvanceOptions from "./pages/AdvanceOptions";
import PoolReports from "./pages/PoolReports";
import LoanContract from "./pages/LoanContract";
import FutureContractInfo from "./pages/FutureContractInfo";
import ContractInformation from "./pages/ContractInformation";
import ContractDescriptionTemplates from "./pages/ContractDescriptionTemplates";
import OpenShift from "./pages/OpenShift";
import InventoryCategory from "./pages/InventoryCategory";
import PurchaseInventoryList from "./pages/PurchaseInventoryList";
import SystemInventory from "./pages/SystemInventory";
import ContractComplete from "./pages/ContractComplete";
import PurchaseReport from "./pages/PurchaseReport";
import InvestorCustomerReport from "./pages/InvestorCustomerReport";
import DealerChangePassword from "./pages/DealerChangePassword";
import CompletedContracts from "./pages/CompletedContracts";
import TransactionReports from "./pages/TransactionReports";
import DetailedOperationalReport from "./pages/DetailedOperationalReport";
import VerifyOTP from "./pages/VerifyOTP";
import NotesSheet from "./pages/NoteSheet";
import InvestorDepositWithdraw from "./pages/InvestorDepositWithdraw";
import CustomerContracts from "./pages/CustomerContracts";
import InvestorStatment from "./pages/InvestorStatment";
import SellItemList from "./pages/SellItemList";
import SellItem from "./pages/SellItem";
import SellItemReport from "./pages/SellItemReport";
import ExpenseReport from "./pages/ExpenseReport";
import OperationalReport from "./pages/OperationalReport";
import PaymentReports from "./pages/PaymentReports";
import AllContractsReport from "./pages/AllContractsReport";
import BranchUsers from "./pages/BranchUsers";
import AddBranchUser from "./pages/AddBranchUser";
import BranchChat from "./pages/BranchChat";
import CancelledContractReport from "./pages/CancelledContractReport";
import ContractHeader from "./pages/ContractHeader";
import GeneralReport from "./pages/GeneralReport";
import AddContractLight from "./pages/AddContractLight";

const OpenShiftWrapper = ({ lang, dirFormat }) => {
  const { onShiftOpened } = useOutletContext() || {};
  return <OpenShift lang={lang} dirFormat={dirFormat} onShiftOpened={onShiftOpened} />;
};

const DashboardRouteWrapper = ({ lang, dirFormat }) => {
  let userRole = null;
  try {
    const session = sessionStorage.getItem("aman-admin");
    if (session) {
      const parsedSession = JSON.parse(session);
      const admin = JSON.parse(parsedSession?.admin || "{}");
      userRole = admin?.role;
    }
  } catch (e) { }

  if (userRole && !hasModuleAccess(userRole, "dashboard")) {
    const userModules = rolesConfig[userRole]?.modules || [];
    const firstModule = userModules.find((mod) => mod !== "dashboard") || "customer";
    return <Navigate to={`/dashboard/${firstModule}`} replace />;
  }

  return <Dashboard lang={lang} dirFormat={dirFormat} />;
};

export const App = () => {
  const [language, setLanguage] = useState({});
  const [currentLang, setCurrentLang] = useState(
    localStorage.getItem("AC-lang") || "ar"
  );
  const [dir, setDir] = useState("ltr");

  const currentDir = (dir) => {
    setDir(dir);
  };

  const currentLangFunc = (lang) => {
    setCurrentLang(lang);
    localStorage.setItem("AC-lang", lang);
  };

  useEffect(() => {
    axios
      .get(`${apiKey}/get-lang?lang=${currentLang}`)
      .then((res) => {
        setLanguage(JSON.parse(res.data.result[0].lang_keys));
      })
      .catch((err) => {
        console.error(err);
      });
  }, [currentLang]);

  return (
    <BrowserRouter>
      <Routes>
        {/* Public Routes */}
        <Route path="/" element={<LoginPage />} />
        <Route path="/portal-login" element={<PortalLoginPage />} />
        <Route
          path="/forgot-password"
          element={<ForgotPassword lang={language} />}
        />
        <Route
          path="/reset-password"
          element={<ResetPassword lang={language} />}
        />
        <Route
          path="/contract/:customer_id"
          element={
            <PublicContract
              lang={language}
              dir={dir}
              currentDir={currentDir}
              currentLangFunc={currentLangFunc}
            />
          }
        />

        {/* Customer Panel Protected Routes */}
        <Route element={<CustomerPrivateRoute />}>
          <Route
            path="/customer-panel"
            element={
              <CustomerLayout
                language={language}
                dir={dir}
                currentDir={currentDir}
                currentLangFunc={currentLangFunc}
              />
            }
          >
            <Route index element={<CustomerDashboard lang={language} />} />
            <Route path="contracts" element={<CustomerContractsHistory lang={language} />} />
            <Route path="apply-contract" element={<ApplyContractForm lang={language} />} />
            <Route path="applications" element={<CustomerApplicationsList lang={language} />} />
            <Route path="reports" element={<CustomerReportsPage lang={language} />} />
            <Route path="profile" element={<CustomerProfilePage lang={language} />} />
          </Route>
        </Route>

        {/* Investor Panel Protected Routes */}
        <Route element={<InvestorPrivateRoute />}>
          <Route
            path="/investor-panel"
            element={
              <InvestorLayout
                language={language}
                dir={dir}
                currentDir={currentDir}
                currentLangFunc={currentLangFunc}
              />
            }
          >
            <Route index element={<InvestorDashboardPage lang={language} />} />
            <Route path="transactions" element={<InvestorTransactionsPage lang={language} />} />
            <Route path="statement" element={<InvestorStatementPage lang={language} />} />
            <Route path="pools" element={<InvestorPoolsPage lang={language} />} />
            <Route path="profile" element={<InvestorProfilePage lang={language} />} />
          </Route>
        </Route>

        {/* Private Authenticated Routes */}
        <Route element={<PrivateRoute />}>
          <Route
            path="/dashboard"
            element={
              <DashboardLayout
                language={language}
                dir={dir}
                currentDir={currentDir}
                currentLangFunc={currentLangFunc}
              />
            }
          >
            <Route
              index
              element={
                <DashboardRouteWrapper lang={language} dirFormat={dir} />
              }
            />
            <Route
              path="open-shift"
              element={<OpenShiftWrapper lang={language} dirFormat={dir} />}
            />
            <Route
              path="profile"
              element={<Profie lang={language} dirFormat={dir} />}
            />

            {/* Customer Routes */}
            <Route element={<RoleRoute moduleName="customer" />}>
              <Route
                path="customer"
                element={<Customer lang={language} dirFormat={dir} />}
              />
              <Route
                path="customer/add-customer"
                element={<AddCustomer lang={language} dirFormat={dir} />}
              />
              <Route
                path="customer/edit-customer/:id"
                element={<AddCustomer lang={language} dirFormat={dir} />}
              />
              <Route
                path="customer/add-lightmode-customer"
                element={<AddLightCustomer lang={language} dirFormat={dir} />}
              />
              <Route
                path="customer/edit-lightmode-customer/:id"
                element={<AddLightCustomer lang={language} dirFormat={dir} />}
              />
              <Route
                path="customer/contracts/:id"
                element={
                  <CustomerContracts lang={language} dirFormat={dir} />
                }
              />
              <Route
                path="customer/profile/:user_type/:id"
                element={<UserProfile lang={language} dirFormat={dir} />}
              />
              <Route
                path="contract-applications"
                element={
                  <BranchContractApplications lang={language} dirFormat={dir} />
                }
              />
            </Route>

            {/* Guarantors */}
            <Route element={<RoleRoute moduleName="customer-manager" />}>
              <Route
                path="customer-manager"
                element={<CusManGuarantor lang={language} dirFormat={dir} />}
              />
              <Route
                path="customer-manager/add-guarantor"
                element={<AddCusgarantor lang={language} dirFormat={dir} />}
              />
              <Route
                path="customer-manager/edit-guarantor/:id"
                element={<AddCusgarantor lang={language} dirFormat={dir} />}
              />
              <Route
                path="customer-manager/add-light-guarantor"
                element={<AddLightGuarantor lang={language} dirFormat={dir} />}
              />
              <Route
                path="customer-manager/edit-light-guarantor/:id"
                element={<AddLightGuarantor lang={language} dirFormat={dir} />}
              />
            </Route>

            {/* Investor & Investment Routes */}
            <Route element={<RoleRoute moduleName="investor-report" />}>
              <Route
                path="investor-report"
                element={<InvestorRep lang={language} dirFormat={dir} />}
              />
              <Route
                path="investor-report/add-investor"
                element={<Addinvestor lang={language} dirFormat={dir} />}
              />
              <Route
                path="investor-report/edit-investor/:id"
                element={<Addinvestor lang={language} dirFormat={dir} />}
              />
              <Route
                path="investor-report/add-lightmode-investor"
                element={<AddLightInvestor lang={language} dirFormat={dir} />}
              />
              <Route
                path="investor-report/edit-lightmode-investor/:id"
                element={<AddLightInvestor lang={language} dirFormat={dir} />}
              />
              <Route
                path="investor-report/transaction/:id/:process"
                element={
                  <InvestorDepositWithdraw lang={language} dirFormat={dir} />
                }
              />
              <Route
                path="investor-report/profile/:user_type/:id"
                element={<UserProfile lang={language} dirFormat={dir} />}
              />
            </Route>

            <Route element={<RoleRoute moduleName="investor-statement" />}>
              <Route
                path="investor-statement"
                element={<InvestorStatment lang={language} dirFormat={dir} />}
              />
            </Route>

            <Route element={<RoleRoute moduleName="investment-pool" />}>
              <Route
                path="investment-pool"
                element={<InvestmentPool lang={language} dirFormat={dir} />}
              />
              <Route
                path="investment-pool/add-new-pool"
                element={<AddNewPool lang={language} dirFormat={dir} />}
              />
            </Route>

            {/* Inventory Routes */}
            <Route element={<RoleRoute moduleName="inventory-category" />}>
              <Route
                path="inventory-category"
                element={<InventoryCategory lang={language} dirFormat={dir} />}
              />
            </Route>

            <Route element={<RoleRoute moduleName="inventory-system" />}>
              <Route
                path="inventory-system"
                element={<SystemInventory lang={language} dirFormat={dir} />}
              />
            </Route>

            <Route element={<RoleRoute moduleName="inventory" />}>
              <Route
                path="inventory"
                element={
                  <PurchaseInventoryList lang={language} dirFormat={dir} />
                }
              />
              <Route
                path="inventory/inventory-purchase"
                element={
                  <PurchaseInventory lang={language} dirFormat={dir} />
                }
              />
              <Route
                path="inventory/inventory-purchase/edit-purchase/:id"
                element={
                  <PurchaseInventory lang={language} dirFormat={dir} />
                }
              />
            </Route>

            <Route element={<RoleRoute moduleName="sell-item-list" />}>
              <Route
                path="sell-item-list"
                element={<SellItemList lang={language} dirFormat={dir} />}
              />
              <Route
                path="sell-item-list/sell-new-item"
                element={<SellItem lang={language} dirFormat={dir} />}
              />
              <Route
                path="sell-item-list/edit-sale/:id"
                element={<SellItem lang={language} dirFormat={dir} />}
              />
            </Route>

            {/* Accounts & Expenses */}
            <Route element={<RoleRoute moduleName="accounts" />}>
              <Route
                path="accounts"
                element={<Accounts lang={language} dirFormat={dir} />}
              />
            </Route>

            <Route element={<RoleRoute moduleName="expenses" />}>
              <Route
                path="expenses"
                element={<Expenses lang={language} dirFormat={dir} />}
              />
            </Route>

            {/* Contracts */}
            <Route element={<RoleRoute moduleName="contracts" />}>
              <Route
                path="contracts"
                element={<Contracts lang={language} dirFormat={dir} />}
              />
              <Route
                path="customer/contract-information/:customer_id"
                element={
                  <ContractInformation lang={language} dirFormat={dir} />
                }
              />
              <Route
                path="contracts/valid-contract"
                element={<ValidCon lang={language} dirFormat={dir} />}
              />
              <Route
                path="contracts/description-templates"
                element={
                  <ContractDescriptionTemplates
                    lang={language}
                    dirFormat={dir}
                  />
                }
              />
              <Route
                path="contracts/contract-header"
                element={<ContractHeader lang={language} dirFormat={dir} />}
              />
              <Route
                path="contracts/valid-contract/complete-contract/:contract_id"
                element={
                  <ContractComplete lang={language} dirFormat={dir} />
                }
              />
              <Route
                path="contracts/valid-contract/add-new-valid"
                element={<AddNewValid lang={language} dirFormat={dir} />}
              />
              <Route
                path="contracts/valid-contract/edit/:id"
                element={<AddContractLight lang={language} dirFormat={dir} />}
              />
              <Route
                path="contracts/basic-information"
                element={<BasicInfo lang={language} dirFormat={dir} />}
              />
              <Route
                path="contracts/future/basic-information"
                element={<BasicInfo lang={language} dirFormat={dir} />}
              />
              <Route
                path="contracts/identification"
                element={<Identification lang={language} dirFormat={dir} />}
              />
              <Route
                path="contracts/future/identification"
                element={<Identification lang={language} dirFormat={dir} />}
              />
              <Route
                path="contracts/contract-information"
                element={<ContractInfo lang={language} dirFormat={dir} />}
              />
              <Route
                path="contracts/future/contract-information"
                element={
                  <FutureContractInfo lang={language} dirFormat={dir} />
                }
              />
              <Route
                path="contracts/valid-contract/add-loan-contract"
                element={<LoanContract lang={language} dirFormat={dir} />}
              />
              <Route
                path="contracts/light-contract"
                element={
                  <AddContractLight lang={language} dirFormat={dir} />
                }
              />
              <Route
                path="contracts/future/light-contract"
                element={
                  <AddContractLight lang={language} dirFormat={dir} />
                }
              />
            </Route>

            {/* Advance Options */}
            <Route element={<RoleRoute moduleName="advance-options" />}>
              <Route
                path="advance-options"
                element={<AdvanceOptions lang={language} dirFormat={dir} />}
              />
            </Route>

            {/* Branch Users */}
            <Route element={<RoleRoute moduleName="branch-users" />}>
              <Route
                path="branch-users"
                element={<BranchUsers lang={language} dirFormat={dir} />}
              />
              <Route
                path="add-branch-user"
                element={<AddBranchUser lang={language} dirFormat={dir} />}
              />
            </Route>

            {/* Reports */}
            <Route element={<RoleRoute moduleName="report" />}>
              <Route
                path="report"
                element={<Report lang={language} dirFormat={dir} />}
              />
              <Route
                path="report/list-of-contract"
                element={
                  <ListOfContract
                    path={language.Profit_Contract || "Profit Contracts"}
                    heading={
                      language.List_of_Profit_Contract ||
                      "List Of Profit Contract"
                    }
                    lang={language}
                    dirFormat={dir}
                  />
                }
              />
              <Route
                path="report/defaulted-contracts"
                element={
                  <ListOfContract
                    path={language.Defaulted_Contracts || "Defaulted Contracts"}
                    heading={
                      language.Defaulted_Contracts || "Defaulted Contracts"
                    }
                    lang={language}
                    dirFormat={dir}
                    status={3}
                  />
                }
              />
              <Route
                path="report/contract-profit"
                element={
                  <CompletedContracts
                    path={language.complete_contract || "Complete Contract"}
                    heading={
                      language.complete_contract || "Complete Contract"
                    }
                    lang={language}
                    dirFormat={dir}
                    status={2}
                  />
                }
              />
              <Route
                path="report/cancelled-contracts/:id"
                element={
                  <CancelledContractReport
                    path={
                      language.Cancelled_Contracts || "Cancelled Contracts"
                    }
                    heading={
                      language.Cancelled_Contracts || "Cancelled Contracts"
                    }
                    lang={language}
                    dirFormat={dir}
                    status={4}
                  />
                }
              />
              <Route
                path="report/pure-contracts"
                element={
                  <ListOfContract
                    path={language.Pure_Contracts || "Pure Contracts"}
                    heading={language.Pure_Contracts || "Pure Contracts"}
                    lang={language}
                    dirFormat={dir}
                    type={1}
                  />
                }
              />
              <Route
                path="report/installment-payments"
                element={
                  <ListOfContract
                    path={
                      language.Future + " " + language.Contracts ||
                      "Future Contracts"
                    }
                    heading={
                      language.Future + " " + language.Contracts ||
                      "Future Contracts"
                    }
                    lang={language}
                    dirFormat={dir}
                    type={2}
                  />
                }
              />
              <Route
                path="report/user-report"
                element={<UserReport lang={language} dirFormat={dir} />}
              />
              <Route
                path="report/activity-logs"
                element={<ActivityLogReport lang={language} dirFormat={dir} />}
              />
              <Route
                path="report/investor-report-list"
                element={<InvestorReport lang={language} dirFormat={dir} />}
              />
              <Route
                path="report/investor-user-report"
                element={
                  <InvestorCustomerReport lang={language} dirFormat={dir} />
                }
              />
              <Route
                path="report/purchase-report"
                element={<PurchaseReport lang={language} />}
              />
              <Route
                path="report/invest-report-list"
                element={<InvestReport lang={language} dirFormat={dir} />}
              />
              <Route
                path="report/loan-report-list"
                element={<LoanReport lang={language} dirFormat={dir} />}
              />
              <Route
                path="report/item-report-list"
                element={<ItemReport lang={language} dirFormat={dir} />}
              />
              <Route
                path="report/dealer-report-list"
                element={<DealerReport lang={language} dirFormat={dir} />}
              />
              <Route
                path="report/all-contracts"
                element={
                  <AllContractsReport lang={language} dirFormat={dir} />
                }
              />
              <Route
                path="report/pool-report"
                element={<PoolReports lang={language} dirFormat={dir} />}
              />
              <Route
                path="report/transaction-report"
                element={
                  <TransactionReports lang={language} dirFormat={dir} />
                }
              />
              <Route
                path="report/general-report"
                element={<GeneralReport lang={language} dirFormat={dir} />}
              />
              <Route
                path="report/operational-report"
                element={
                  <OperationalReport lang={language} dirFormat={dir} />
                }
              />
              <Route
                path="report/shift-report"
                element={
                  <DetailedOperationalReport lang={language} dirFormat={dir} />
                }
              />
              <Route
                path="report/sell-item-report"
                element={<SellItemReport lang={language} dirFormat={dir} />}
              />
              <Route
                path="report/expense-report"
                element={<ExpenseReport lang={language} dirFormat={dir} />}
              />
              <Route
                path="report/payment-report/:id"
                element={<PaymentReports lang={language} dirFormat={dir} />}
              />
               <Route
              path="report/investor-contract-report"
              element={<InvestorContractReport lang={language} dirFormat={dir} />}
            />
            </Route>

            {/* Additional operational routes */}
            <Route
              path="loan-avail-list"
              element={<LoanAvailList lang={language} dirFormat={dir} />}
            />
            <Route
              path="loan-avail-list/add-new-loan"
              element={<AddLoanRequest lang={language} dirFormat={dir} />}
            />
            <Route
              path="collection-and-pay"
              element={
                <CollectionAndPayment lang={language} dirFormat={dir} />
              }
            />
            <Route
              path="installment-and-pay"
              element={
                <InstallmentAndPayment lang={language} dirFormat={dir} />
              }
            />
            <Route
              path="inventory-loan"
              element={<InventoryLoanList lang={language} dirFormat={dir} />}
            />
            <Route
              path="return"
              element={<Returns lang={language} dirFormat={dir} />}
            />
            <Route
              path="type-of-loan"
              element={<TypeOfLoans lang={language} dirFormat={dir} />}
            />
            <Route
              path="type-of-loan/add-loan-list"
              element={<AddLoanList lang={language} dirFormat={dir} />}
            />
            <Route
              path="add-new-profit"
              element={<AddNewProfit lang={language} dirFormat={dir} />}
            />
            <Route
              path="list-of-del"
              element={<ListOfDel lang={language} dirFormat={dir} />}
            />
            <Route
              path="add-new-del"
              element={<AddNewDel lang={language} dirFormat={dir} />}
            />
            <Route
              path="intsallment-payment"
              element={<InstallmentPayment />}
            />
            <Route
              path="add-new-installment"
              element={<AddNewInstall />}
            />
            <Route
              path="list-commision"
              element={<ListOfContractComision />}
            />
            <Route path="add-commision" element={<AddNewCommision />} />
            <Route
              path="chat"
              element={<BranchChat lang={language} dirFormat={dir} />}
            />
            <Route
              path="loan"
              element={<Loan lang={language} dirFormat={dir} />}
            />
            <Route
              path="item"
              element={<Item lang={language} dirFormat={dir} />}
            />
            <Route
              path="withdraw"
              element={<WithDraw lang={language} dirFormat={dir} />}
            />
            <Route
              path="investment-deposite"
              element={<InvesDeposit lang={language} dirFormat={dir} />}
            />
            <Route
              path="bank-transfer"
              element={<InvesTransfer lang={language} dirFormat={dir} />}
            />
            <Route
              path="dealer-list"
              element={<DealerList lang={language} dirFormat={dir} />}
            />
            <Route
              path="dealer-list/:dealer_id"
              element={
                <DealerChangePassword lang={language} dirFormat={dir} />
              }
            />
            <Route
              path="dealer-list/verify-otp/:id"
              element={<VerifyOTP lang={language} dirFormat={dir} />}
            />
            <Route
              path="dealer-list/add-new-dealer"
              element={<AddNewDealer lang={language} dirFormat={dir} />}
            />
            <Route path="zakat" element={<Zakat />} />
            <Route
              path="notes"
              element={<NotesSheet lang={language} dirFormat={dir} />}
            />

            {/* Fallback to Dashboard */}
            <Route
              path="*"
              element={
                <DashboardRouteWrapper lang={language} dirFormat={dir} />
              }
            />
          </Route>
        </Route>

        {/* Catch-all redirect */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
};

export default App;
